import React, { PropsWithChildren } from "react";
import { Box, Divider, Stack, Tab, Tabs, Typography } from "@mui/material";
// import { functions } from "../../../services/firebase";
import { useTranslation } from "react-i18next";

export interface IHelpCategoriesProps<T> {
    selectedCategory: T;
    categories: {
        value: T;
        title: string;
    }[];
    onCategoryChange: (value: T) => void;
}

/** The display of all the topics with tabs to select one category */
export function HelpCategories<T>({
    selectedCategory,
    categories,
    onCategoryChange,
    children,
}: PropsWithChildren<IHelpCategoriesProps<T>>) {
    const { t } = useTranslation();
    const handleChange = (_: React.SyntheticEvent, newValue: T) => {
        onCategoryChange(newValue);
    }
    return (
        <Stack direction={'column'}>
            <Typography variant="h1">{t('help.breadcrumbs.allTopicsLabel')}</Typography>
            <Typography>{t('help.page.allTopics')}</Typography>
            <Tabs
                value={!!selectedCategory && selectedCategory}
                onChange={handleChange}
            >
                {
                    categories.map((cat, index) =>
                        <Tab key={`cat-index-${index}`} label={cat.title} value={cat.value} />
                    )
                }
            </Tabs>
            <Divider />
            <Box sx={{ py: 2, px: 1 }}>
                {children}
            </Box>
        </Stack>
    )
}